module.exports = __webpack_public_path__ + "static/media/03-1-galeria-01-pronovias@2x.455329ab.jpg";